<ng-container *ngIf="loading">
  <div class="spinner-container">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </div>
</ng-container>
<ng-container *ngIf="!loading">
  <div class="upper-part">
    <div class="fields-container">
      <div
        *ngIf="associationType === 'SignTitleAdjustment'"
        class="flex-row field-input"
      >
        <label>Tekst</label>
        <mat-form-field appearance="outline">
          <input matInput [(ngModel)]="assocObject.title" />
        </mat-form-field>
      </div>
      <div
        *ngIf="associationType === 'SignPhoneNumberAdjustment'"
        class="flex-row field-input"
      >
        <label>Tekst</label>
        <mat-form-field appearance="outline">
          <input matInput [(ngModel)]="assocObject.phoneNumber" />
        </mat-form-field>
      </div>
      <div
        *ngIf="associationType === 'SignStickerDetail'"
        class="flex-row field-input"
      >
        <label>Tekst</label>
        <mat-form-field appearance="outline">
          <input matInput [(ngModel)]="assocObject.text" />
        </mat-form-field>
      </div>

      <div class="flex-row field-input">
        <label>Stand./cust.</label>
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            [(ngModel)]="assocObject.standard"
          >
            <mat-option [value]="true">Standaard</mat-option>
            <mat-option [value]="false">Custom</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        *ngIf="associationType === 'SignStickerDetail'"
        class="flex-row field-input"
      >
        <label>Locatie</label>
        <mat-form-field appearance="outline">
          <input matInput [(ngModel)]="assocObject.location" />
        </mat-form-field>
      </div>

      <div class="flex-row field-input">
        <label>Hoogte</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="assocObject.height" />
          <div matSuffix>cm</div>
        </mat-form-field>
      </div>

      <div class="flex-row field-input">
        <label>Breedte</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="assocObject.width" />
          <div matSuffix>cm</div>
        </mat-form-field>
      </div>

      <div class="flex-row field-input">
        <label>Kleur tekst</label>
        <mat-form-field appearance="outline">
          <input matInput [(ngModel)]="assocObject.textColor" />
        </mat-form-field>
      </div>

      <div class="flex-row field-input">
        <label>Kleur fond</label>
        <mat-form-field appearance="outline">
          <input matInput [(ngModel)]="assocObject.foundationColor" />
        </mat-form-field>
      </div>

      <div class="flex-row field-input">
        <label>In voorraad</label>
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            [(ngModel)]="assocObject.inStock"
          >
            <mat-option [value]="true">Ja</mat-option>
            <mat-option [value]="false">Nee</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="examples-container">
      <association-examples [assocObject]="assocObject"></association-examples>
    </div>
  </div>

  <div class="upper-part double-less-upper-space">
    <div class="fields-container">
      <conditional-price
        [booleanLabel]="'Aanrekenen'"
        [labelStyle]="{ 'margin-bottom': '20px' }"
        [inputFieldStyle]="{ 'margin-top': '-20px' }"
        [(ngModel)]="assocObject.charge"
      ></conditional-price>
    </div>

    <div class="graphics-complete-container upper-space">
      <div class="align-to-bottom">
        <div class="flex-row justify-content-between">
          <label class="complete-label">Grafisch afgewerkt</label>
          <mat-checkbox [(ngModel)]="assocObject.graphicsComplete">
          </mat-checkbox>
        </div>
        <div class="flex-row justify-content-between">
          <label class="complete-label">Admin afgewerkt</label>
          <mat-checkbox [(ngModel)]="assocObject.adminComplete"> </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="d-flex checklist-title">
    <div class="department-checkbox">
      Checkbox
    </div>
    <div class="department-info">
      Omschrijving
    </div>
  </div>

  <div class="d-flex">
    <div class="department-checkbox">
      <div class="small-upper-space">
        <mat-checkbox [(ngModel)]="assocObject.immo">Immo</mat-checkbox>
      </div>
    </div>
    <div class="department-info">
      <textarea-input
        [initContent]="assocObject.immoInfo"
        [placeholder]="''"
        (answer)="immoInfoChange($event)"
      ></textarea-input>
    </div>
  </div>

  <div class="d-flex">
    <div class="department-checkbox">
      <div class="small-upper-space">
        <mat-checkbox [(ngModel)]="assocObject.graphical"
          >Grafische</mat-checkbox
        >
      </div>
    </div>
    <div class="department-info">
      <textarea-input
        [initContent]="assocObject.graphicalInfo"
        [placeholder]="''"
        (answer)="graphicalInfoChange($event)"
      ></textarea-input>
    </div>
  </div>

  <div class="d-flex">
    <div class="department-checkbox">
      <div class="small-upper-space">
        <mat-checkbox [(ngModel)]="assocObject.atelier">Atelier</mat-checkbox>
      </div>
    </div>
    <div class="department-info">
      <textarea-input
        [initContent]="assocObject.atelierInfo"
        [placeholder]="''"
        (answer)="atelierInfoChange($event)"
      ></textarea-input>
    </div>
  </div>

  <div class="d-flex">
    <div class="department-checkbox">
      <div class="small-upper-space">
        <mat-checkbox [(ngModel)]="assocObject.installer"
          >Installateur</mat-checkbox
        >
      </div>
    </div>
    <div class="department-info">
      <textarea-input
        [initContent]="assocObject.installerInfo"
        [placeholder]="''"
        (answer)="installerInfoChange($event)"
      ></textarea-input>
    </div>
  </div>

  <div class="confirm-container">
    <mat-spinner *ngIf="saving" color="primary" diameter="18"></mat-spinner>
    <button
      *ngIf="!saving"
      type="button"
      (click)="close()"
      class="btn btn-main btn-back"
    >
      Annuleer
    </button>
    <button
      *ngIf="!saving"
      type="button"
      (click)="saveAssocObject()"
      mat-button
      class="button"
    >
      Opslaan
    </button>
  </div>
</ng-container>
